export default {
  SET_DISPLAY_CARDS(state, displayCards) {
    state.displayCards = displayCards;
  },

  SET_DISPLAY_LIST(state, displayList) {
    state.displayList = displayList;
  },

  SET_SEARCH_JIRA(state, searchJira) {
    state.searchJira = searchJira;
  },

  SET_SEARCH_CONFLUENCE(state, searchConfluence) {
    state.searchConfluence = searchConfluence;
  },

  SET_SEARCH_PERSONAL(state, searchPersonal) {
    state.searchPersonal = searchPersonal;
  },

  SET_SEARCH_CLOSED(state, searchClosed) {
    state.searchClosed = searchClosed;
  },

  SET_SEARCH_OPENED(state, searchOpened) {
    state.searchOpened = searchOpened;
  },

  SET_SEARCH_STATUS(state, searchStatus) {
    state.searchStatus = searchStatus;
  },

  SET_SORT_KEY(state, sortKey) {
    state.sortKey = sortKey;
  },

  SET_SORT_ORDER(state, sortOrder) {
    state.sortOrder = sortOrder;
  },

  SET_SEARCH_VALUE(state, searchValue) {
    state.searchValue = searchValue;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/mutations.js